import { MdLeaderboard } from 'react-icons/md';
import { Resources } from '../../resource';
import { MainPage } from './main-page';

export const name = Resources.worldCupLeaderboardConfig;

export const list = MainPage;

export const icon = MdLeaderboard;

export const options = { label: 'resource.worldCupLeaderboardConfig' };
